"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecPromotion = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackEecPromotion(eventName, GA4eventName, promotions, data) {
    const { creativeName, creativeSlot, promotionName, promotionId, locationId, promotionPlaceholder, promotionCountdown, positionHorizontal, positionVertical, promotionType, } = data || {};
    let eventData = {};
    if (data && promotionType) {
        const basicEventData = {
            creative_name: creativeName,
            creative_slot: creativeSlot,
            promotion_name: promotionName,
            promotion_id: promotionId,
            location_id: locationId,
        };
        if (promotionType === enums_1.PromotionType.Dynamic) {
            eventData = {
                ...basicEventData,
                promotion_placeholder: promotionPlaceholder,
                promotion_countdown: promotionCountdown,
            };
        }
        else if (promotionType === enums_1.PromotionType.Static) {
            eventData = {
                ...basicEventData,
                position_horizontal: positionHorizontal,
                position_vertical: positionVertical,
            };
        }
    }
    const promoEventName = eventName === enums_1.EventName.EECPromotionClick ? 'promoClick' : 'promoView';
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        ecommerce: {
            [promoEventName]: {
                promotions,
            },
        },
        ...(!!Object.keys(eventData).length && {
            eventData: {
                eventName: GA4eventName,
                feature_category: promotionType === enums_1.PromotionType.Dynamic
                    ? enums_1.GA4FeatureCategory.PromotionDynamic
                    : enums_1.GA4FeatureCategory.PromotionStatic,
                ...eventData,
                ecommerce: {
                    items: [
                        {
                            ...eventData,
                            promotion_type: promotionType,
                        },
                    ],
                },
            },
        }),
    }, eventName);
}
exports.trackEecPromotion = trackEecPromotion;
//# sourceMappingURL=trackEecPromotion.js.map